const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
const SELECTOR = '[data-responsive-mobile-padding]';
const MOBILE_ACCORDION_SELECTOR = '.group-block__mobile-accordion';
const ORIGINAL_PADDING = new WeakMap();
const INITIALIZED_ACCORDIONS = new WeakSet();

function responsivePaddingValue(value) {
  const pixels = Number.parseFloat(value) || 0;
  return pixels > 20 ? `max(20px, calc(var(--spacing-scale, var(--spacing-scale-md)) * ${pixels}px))` : `${pixels}px`;
}

function applyResponsivePadding(root = document) {
  const elements = [];
  if (root instanceof Element && root.matches(SELECTOR)) elements.push(root);
  elements.push(...(root.querySelectorAll?.(SELECTOR) ?? []));

  for (const element of elements) {
    if (!ORIGINAL_PADDING.has(element)) ORIGINAL_PADDING.set(element, element.style.padding);

    if (!MOBILE_QUERY.matches) {
      const originalPadding = ORIGINAL_PADDING.get(element);
      if (originalPadding) element.style.padding = originalPadding;
      else element.style.removeProperty('padding');
      continue;
    }

    const values = element.dataset.responsiveMobilePadding
      ?.split(',')
      .map(responsivePaddingValue);
    if (values?.length === 4) element.style.setProperty('padding', values.join(' '));
  }
}

function applyResponsiveAccordions(root = document) {
  const accordions = [];
  if (root instanceof Element && root.matches(MOBILE_ACCORDION_SELECTOR)) accordions.push(root);
  accordions.push(...(root.querySelectorAll?.(MOBILE_ACCORDION_SELECTOR) ?? []));

  for (const accordion of accordions) {
    if (!MOBILE_QUERY.matches) {
      accordion.setAttribute('open', '');
      accordion.dataset.responsiveDesktopOpen = 'true';
    } else if (
      !INITIALIZED_ACCORDIONS.has(accordion) ||
      accordion.dataset.responsiveDesktopOpen === 'true'
    ) {
      accordion.removeAttribute('open');
      delete accordion.dataset.responsiveDesktopOpen;
    }

    INITIALIZED_ACCORDIONS.add(accordion);
  }
}

applyResponsivePadding();
applyResponsiveAccordions();
MOBILE_QUERY.addEventListener('change', () => {
  applyResponsivePadding();
  applyResponsiveAccordions();
});

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.type === 'attributes' && mutation.target instanceof Element) {
      applyResponsivePadding(mutation.target);
      continue;
    }

    for (const node of mutation.addedNodes) {
      if (node instanceof Element) {
        applyResponsivePadding(node);
        applyResponsiveAccordions(node);
      }
    }
  }
}).observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['data-responsive-mobile-padding'],
  childList: true,
  subtree: true,
});
